var map = {
	"./Hillary_online_world_real_world_video_cover.jpg": 1082,
	"./NWB_children_video_cover.jpg": 1083,
	"./btn_primaryschool_OFF.png": 1084,
	"./btn_secondaryschool_01_Generaltips.png": 1085,
	"./btn_secondaryschool_02_Socialmediauserguide.png": 1086,
	"./btn_secondaryschool_03_quiz.png": 1087,
	"./btn_secondaryschool_04_Riskanddanger.png": 1088,
	"./btn_secondaryschool_05_video.png": 1089,
	"./btn_secondaryschool_06_game.png": 1090,
	"./btn_secondaryschool_07_TheNetizenPledge.png": 1091,
	"./btn_secondaryschool_ON.png": 1092
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1081;